import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { Folder } from "~/api/model";
import { CaseStatusBadge } from "~/components/CaseStatusBadge";
import { DemoBadge } from "~/components/DemoBadge";
import { formatDate } from "~/helpers";
import { CaseActions } from "./CaseActions";

interface CaseCardProps {
  caseItem: Folder;
  onCaseClick: (caseId: string) => void;
}

export const CaseCard: FC<CaseCardProps> = ({ caseItem, onCaseClick }) => {
  const counts = caseItem.counts!;
  return (
    <div
      className="flex flex-col p-4 border-b bg-background active:bg-accent cursor-pointer"
      onClick={() => onCaseClick(caseItem.id)}
      style={{ height: "120px" }}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-medium text-sm text-foreground truncate">
              {caseItem.name}
            </span>
            {caseItem.isDemo && <DemoBadge />}
          </div>
          <div className="flex items-center gap-2">
            <CaseStatusBadge counts={counts} chatStatus={caseItem.chatStatus} />
          </div>
        </div>
        <div onClick={(e) => e.stopPropagation()}>
          <CaseActions caseId={caseItem.id} />
        </div>
      </div>

      <div className="mt-auto grid grid-cols-2 gap-2 text-xs text-muted-foreground">
        <div>
          <span className="text-muted-foreground/70">
            <FormattedMessage id="claimNumberLabel" defaultMessage="Claim #" />
            :{" "}
          </span>
          <span>{caseItem.claimNumber || "-"}</span>
        </div>
        <div>
          <span className="text-muted-foreground/70">
            <FormattedMessage id="casesList.created" defaultMessage="Created" />
            :{" "}
          </span>
          <span>{formatDate(caseItem.createdAt)}</span>
        </div>
      </div>
    </div>
  );
};
